import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import { withWidth, Paper, Grid, TextField, Button, CircularProgress, Typography, Hidden } from '@material-ui/core'
import { Modal } from 'swx-atomic-component-lib'
import _ from 'lodash'
import { connect } from 'react-redux'
import { authenticateUser, checkLoggedin, getLoginProviderMethodForUser, verifyAndSendToken, forgotPassword, resetPassword } from '../actions/users'
import queryString from 'query-string'
import colors from '../helpers/color.helper'
import util from '../helpers/util.helper'
import EnvelopeIcon from 'calcite-ui-icons-react/EnvelopeIcon'
import { Info, Check } from '@material-ui/icons'
import TempCodeVerification from './tempCodeVerifcation'
import i18n from '../i18n'

const styles = theme => ({
  container: {
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/shapes-lines-large.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'calc(50% - 257px) calc(50% - 214px)',
    [theme.breakpoints.down('sm')]: {
      minHeight: 450,
      backgroundSize: '1104.75px 1089.75px'
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: 760
    },
    [theme.breakpoints.down('xs')]: {
      backgroundSize: '736.5px 726.5px',
      backgroundPosition: 'top right'
    }
  },
  form: {
    flex: 1,
    [theme.breakpoints.down('xs')]: {
      paddingTop: '14vh'
    }
  },
  logo: {
    position: 'absolute',
    [theme.breakpoints.up('lg')]: {
      top: 240,
      left: 241,
      height: 51,
      width: 235
    },
    [theme.breakpoints.down('lg')]: {
      top: 200,
      left: 201,
      height: 51,
      width: 235
    },
    [theme.breakpoints.down('md')]: {
      top: 100,
      left: 100.8,
      height: 38.3,
      width: 176.3
    },
    [theme.breakpoints.down('sm')]: {
      top: 50,
      left: 75.8,
      height: 38.3,
      width: 176.3
    },
    [theme.breakpoints.down('xs')]: {
      position: 'inherit',
      height: 38.3,
      width: 176.3
    }
  },
  paper: theme.mixins.gutters({
    width: 480,
    background: 'none',
    boxShadow: 'none',
    [theme.breakpoints.down('xs')]: {
      width: 295
    }
  }),
  welcome: {
    color: colors.blue
  },
  envelope: {
    position: 'relative',
    bottom: -44,
    left: -36,
    [theme.breakpoints.down('xs')]: {
      left: 20,
      bottom: -44,
      zIndex: 100
    }
  },
  info: {
    position: 'relative',
    height: 20,
    width: 20,
    bottom: 40,
    left: -36,
    [theme.breakpoints.down('xs')]: {
      left: 20,
      bottom: 105
    }
  },
  infoBox: {
    height: 40,
    width: 193
  },
  link: {
    textDecoration: 'none',
    color: colors.blue
  },
  reset: {
    marginLeft: 50,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      marginTop: 20
    }
  },
  iconButton: {
    '&:hover': {
      backgroundColor: 'transparent'
    },
    height: 16,
    width: 16
  },
  icon: {
    height: 16,
    width: 16
  },
  loading: {
    color: colors.white,
    height: '16px !important',
    width: '16px !important'
  },
  success: {
    height: 48,
    width: 48,
    backgroundColor: colors.success,
    borderRadius: '50%',
    marginLeft: 165
  },
  tick: {
    height: 24,
    width: 24,
    color: colors.white,
    margin: 12
  },
  email: {
    [theme.breakpoints.down('xs')]: {
      '& input': {
        paddingLeft: 48
      }
    }
  },
  emailError: {
    [theme.breakpoints.down('xs')]: {
      '& input': {
        paddingLeft: 48
      }
    },
    '& input': {
      boxShadow: 'none !important',
      border: `1px solid ${colors.error}`,
      '&:focus': {
        boxShadow: `0 0 0 1px ${colors.error} !important`
      }
    }
  }
})

class ForgotPassword extends Component {
  state = {
    initial: true,
    email: null,
    password: null,
    isRedirecting: false,
    redirectTo: null,
    focusedOnPassword: false,
    openMagicModal: false,
    disableButton: false,
    formError: {}
  }

  constructor (props) {
    super(props)
    this.classes = props.classes
  }

  handleCheckLoginProviderForEmail = () => {
    const { email } = this.state
    if (email) {
      const validEmail = util.validateEmail(email)
      if (validEmail) {
        this.setState({ disableButton: false })
        this.props.getLoginProviderMethodForUser(this.state.email)
      } else {
        this.setState({ disableButton: true, formError: { field: 'email', message: i18n.forgetPasswordPage.error.email } })
      }
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const { email } = this.state
    if (_.isEmpty(_.trim(email))) {
      return
    }
    const data = {
      email: this.state.email,
      resetPassword: true
    }
    this.props.resetPassword(data)
  }

  handleChange = (e) => {
    if (_.isEmpty(e.target.value)) {
      this.handleClickAway()
    } else {
      if (!this.state.focusedOnPassword) {
        this.setState({ focusedOnPassword: true })
      }
    }
    const state = this.state
    state[e.target.name] = e.target.value
    state.formError = {}
    this.setState(state)
  }

  handleClickAway = () => {
    this.setState({
      focusedOnPassword: false
    })
  }

  handleCloseModal = () => {
    this.setState({ openMagicModal: false })
  }

  handleRequestMagicCode = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const { email } = this.state
    if (_.isEmpty(_.trim(email))) {
      return
    }
    this.props.forgotPassword({ email }).then(() => {
      this.setState({ openMagicModal: true })
    }, err => {
      this.setState({ errors: err })
    })
  }

  isMobile = () => {
    return _.isEqual(this.props.width, 'xs')
  }

  render () {
    const { classes, error, isCheckingServiceProvider, provider, location, resetEmailSent, isAskingForPassword, badCredentials } = this.props
    const { isRedirecting, isAuthenticated, redirectTo, disableButton, openMagicModal, formError, isLoading, email } = this.state

    if (isRedirecting) {
      return (i18n.loginPage.loading)
    }
    if (isAuthenticated) {
      return <Redirect to='/appLauncher' />
    }

    if (redirectTo) {
      return <Redirect to={{ ...location, pathname: redirectTo }} />
    }

    return (
      <div id='forgot-password' className={classes.container}>
        <Grid
          container
          spacing={0}
          className={classes.form}
          alignItems='center'
          direction='column'
          justify='center'
        >
          <Grid item container justify='center'>
            <Link to='/'><img src='black.svg' alt='SmarterWX Identity Logo' className={classes.logo} /></Link>
          </Grid>
          <Grid item xs={11} sm={6} md={6} lg={4} xl={4}>
            <Paper elevation={4} className={classes.paper}>
              <Grid container direction='row' style={{ marginBottom: 32 }}>
                <Hidden only='xs'>
                  <Typography variant='h6' className={classes.welcome}>{i18n.forgetPasswordPage.title1}</Typography>
                  <span>&nbsp;&nbsp;</span>
                  <Typography variant='h6'>{i18n.forgetPasswordPage.title2}</Typography>
                </Hidden>
              </Grid>
              <Grid container direction='row' style={{ height: 16 }}>
                {
                  provider && provider.loginURL && (
                    setTimeout(() => {
                      window.location.href = provider.loginURL
                    }, 1000)
                  ) &&
                    <Typography color='error'>{i18n.forgetPasswordPage.providerRedirecting}</Typography>
                }
                {
                  !_.isEmpty(formError) && !badCredentials && (
                    <Typography color='error'>{formError.message}<span>&nbsp;&nbsp;</span></Typography>
                  )
                }
              </Grid>
              <form onSubmit={this.handleSubmit}>
                <EnvelopeIcon className={classes.envelope} color={(error && Object.prototype.hasOwnProperty.call(error, 'email')) ? colors.error : colors.blue} size={16} />
                <TextField
                  InputProps={{ readOnly: Boolean(queryString.parse(location.search).email) }}
                  id='email'
                  name='email'
                  onChange={this.handleChange}
                  onBlur={this.handleCheckLoginProviderForEmail}
                  type='email'
                  placeholder={this.isMobile() ? null : i18n.forgetPasswordPage.emailPlaceholder}
                  margin='normal'
                  autoComplete='username'
                  fullWidth
                  value={queryString.parse(location.search).email}
                  error={error && Object.prototype.hasOwnProperty.call(error, 'email')}
                  disabled={isCheckingServiceProvider}
                  className={!_.isEmpty(formError) && formError.field === 'email' ? classes.emailError : classes.email}
                />
                <br />
                <Grid container alignItems='center' direction={this.isMobile() ? 'column' : 'row'} style={{ marginTop: 10 }}>
                  <Hidden only='xs'>
                    <div className={classes.infoBox}><Typography variant='body2'>{i18n.forgetPasswordPage.info}</Typography></div>
                  </Hidden>
                  {
                    resetEmailSent
                      ? <div className={classes.success}><Check className={classes.tick} /></div>
                      : (
                        <Button
                          color='primary'
                          variant='contained'
                          type='submit'
                          fullWidth={this.isMobile()}
                          className={classes.reset}
                          disabled={disableButton || !isAskingForPassword}
                        >
                          {isLoading ? <span>{i18n.forgetPasswordPage.button.loading}&nbsp;</span> : i18n.forgetPasswordPage.button.normal}
                          {(isLoading) && <CircularProgress className={classes.loading} />}
                        </Button>
                        )
                  }
                </Grid>
                <Hidden only='xs'>
                  <Info className={classes.info} color={colors.black} />
                </Hidden>
              </form>
              <Grid style={{ marginTop: this.isMobile() ? 20 : 0 }} container item spacing={0} alignItems='flex-start' direction={this.isMobile() ? 'row' : 'column'}>
                <Grid item>
                  <Typography style={{ marginBottom: this.isMobile() ? 0 : 20 }} variant='body2' onClick={this.handleRequestMagicCode} className={classes.link}>
                    <Link to={{ pathname: '/forgot', search: location.search }} className={classes.link}>
                      {i18n.common.magicCodeLink}
                    </Link>
                  </Typography>
                  <Modal open={openMagicModal}>
                    <TempCodeVerification email={email} onCloseModal={this.handleCloseModal} location={location} />
                  </Modal>
                </Grid>
                <Grid container={this.isMobile()} xs={6} item justify={this.isMobile() ? 'flex-end' : 'flex-start'}>
                  <Typography variant='body2'>
                    <Link to={{ pathname: '/login', search: location.search }} className={classes.link}>
                      {i18n.forgetPasswordPage.returnLink}
                    </Link>
                  </Typography>
                </Grid>
                {/* <Grid item xs={12} sm={6} md={6}>
                  <Typography variant='body2'>Don't have an account? <Link to={{ pathname: '/register', search: this.props.location.search }}>Register</Link></Typography>
                </Grid> */}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}

const ForgotPasswordComponent = withStyles(styles)(withWidth()(ForgotPassword))

function mapStateToProps (state) {
  const { provider, error, isCheckingServiceProvider, isProcessing, user, resetEmailSent } = state.self
  const isAskingForPassword = provider && provider.provider === 'LOCAL'
  const badCredentials = error && _.startsWith(error.message, 'Incorrect email or password')
  return {
    isAskingForPassword,
    provider,
    error,
    isCheckingServiceProvider,
    isProcessing,
    user,
    resetEmailSent,
    badCredentials
  }
}

// Promote Login from a component to a container - it needs to know about this new dispatch method.
export default connect(mapStateToProps, {
  authenticateUser,
  checkLoggedin,
  getLoginProviderMethodForUser,
  verifyAndSendToken,
  forgotPassword,
  resetPassword
})(ForgotPasswordComponent)
